/* eslint-disable react/jsx-props-no-spreading */
import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import queryString from 'query-string';
import { useParams, useSearch } from 'wouter';
import { FormattedMessage } from 'react-intl';
import { FormPanel, Link } from '@micromag/core/components';
import { useUrlGenerator, useRoutePush } from '@micromag/core/contexts';

import { useAuth } from '../../../contexts/AuthContext';
import MainLayout from '../../layouts/Main';
import Page from '../../partials/Page';
import Footer from '../../partials/Footer';
import ResetPasswordForm from '../../forms/ResetPassword';

import styles from '../../../../styles/pages/auth/reset-password.module.scss';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const ResetPasswordPage = ({ className }) => {
    const { token } = useParams();
    const search = useSearch();
    const { setUser } = useAuth();
    const push = useRoutePush();
    const { email } = useMemo(() => queryString.parse(search), [search]);
    const url = useUrlGenerator();
    const onSuccess = useCallback((user) => {
        setUser(user);
        push('account');
    }, []);
    return (
        <MainLayout>
            <Page
                title={
                    <FormattedMessage defaultMessage="Reset password" description="Page title" />
                }
                small
                className={classNames([
                    styles.container,
                    {
                        [className]: className !== null,
                    },
                ])}
            >
                <FormPanel
                    description={
                        <div className={styles.description}>
                            <FormattedMessage
                                defaultMessage="Please update your password."
                                description="Form description"
                            />
                        </div>
                    }
                >
                    <ResetPasswordForm token={token} email={email} onSuccess={onSuccess} />
                    <div className={styles.links}>
                        <Link href={url('auth.login')}>
                            <FormattedMessage
                                defaultMessage="Go back to login"
                                description="Back to login link"
                            />
                        </Link>
                    </div>
                </FormPanel>
            </Page>
            <Footer />
        </MainLayout>
    );
};

ResetPasswordPage.propTypes = propTypes;
ResetPasswordPage.defaultProps = defaultProps;

export default ResetPasswordPage;
